// Vendors
import React, { createContext, useContext, useState } from 'react';
// Enumerations
import { AppStatesEnumeration } from 'enumerations/app-states.enumeration';
// Types
import {
  AppCheckoutOrderContextType,
  AppContextType,
  AppHeaderBackClickType,
  AppStateContextType,
} from './types/app.contexts.type';

const AppContext = createContext<AppContextType>({} as AppContextType);

const AppContextProvider = ({ children }: { children: React.ReactElement }): React.ReactElement => {
  const [currentState, setCurrentState] = useState<AppStateContextType>(
    AppStatesEnumeration.LOADING
  );
  const [onHeaderBackClick, setOnHeaderBackClick] = useState<AppHeaderBackClickType>(null);
  const [checkoutOrderData, setCheckoutOrderData] = useState<AppCheckoutOrderContextType>({});
  const [callbackUrl, setCallbackUrl] = useState<string>('');
  const [loanId, setLoanId] = useState<string>('');
  const [customerName, setCustomerName] = useState<string>('');
  const [clearAllSessionIntervalsProcesses, setClearAllSessionIntervalsProcesses] = useState<
    () => void
  >(() => {});

  return (
    <AppContext.Provider
      value={{
        callbackUrl,
        clearAllSessionIntervalsProcesses,
        checkoutOrderData,
        currentState,
        customerName,
        loanId,
        onHeaderBackClick,
        setCallbackUrl,
        setCheckoutOrderData,
        setClearAllSessionIntervalsProcesses,
        setCurrentState,
        setCustomerName,
        setLoanId,
        setOnHeaderBackClick,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

const useAppContextConsumerHook = (): AppContextType => useContext(AppContext);

export { useAppContextConsumerHook, AppContextProvider };
